<template>
  <div id="ge_game" :standalone="!inIframe()">
    <main ref="main">
      <router-view :key="$router.history.current.meta.section+this.$router.history.current.params.number"></router-view>
    </main>
    <div class="resolution-message" ref="res">
      <Background :small="true"></Background>
      <div class="message-content">
        <div class="bluebar"></div>
        <h1>SCADA Superhero!</h1>
        <p>Take on the challenge of looking after the water supply for Water Town</p>
        <div class="resolution-warning">
          <div>
            <img src="@/assets/img/laptop.svg" >&nbsp;<img src="@/assets/img/tablet.svg" class="tablet-icon">
          </div>
          <div>This game is optimized<br>for desktop or landscape tablet</div>
          <div v-if="rotate"><small>Please rotate your device</small></div>
        </div>
      </div>
    </div>
    <div class="fullscreen" title="Full Screen Mode" v-if="!fullscreenMode" @click="fullScreen(true)" ><img src="@/assets/img/fullscreen.svg" ></div>
    <div class="version">{{version}}</div>
  </div>
</template>

<script>
import '@/assets/scss/fonts.scss'
import '@/assets/scss/reset.scss'
import '@/assets/scss/app.scss'

import Background from '@/components/Background.vue'

export default {
  data: function () {
    return {
      version: '',
      fullscreenMode: false,
      rotate: false
    }
  },
  mounted: function () {
    const self = this
    window.addEventListener('message', function (ev) {
      if (ev.data === 'resize') {
        self.resize()
      }
    })
    window.addEventListener('resize', function () {
      self.resize()
    })
    self.resize()
    fetch('./version.txt?' + Math.random())
      .then(function (response) {
        return response.text()
      })
      .then(function (txt) {
        self.version = txt
      })
    if (!this.fullscreenMethod(document.body)) {
      this.fullScreenMode = false
    }
  },
  components: {
    Background
  },
  methods: {
    fullscreenMethod: function (element) {
      return element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
    },
    requestFullScreen: function (element) {
      const fullscreenMethod = this.fullscreenMethod(element)
      if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
        this.fullscreenMode = true
      } else if (fullscreenMethod) {
        fullscreenMethod.call(element)
        this.fullscreenMode = true
      }
    },
    fullScreen: function (active) {
      if (!active && document.webkitFullscreenElement) {
        document.webkitCancelFullScreen()
      }
      if (active) {
        this.requestFullScreen(document.body)
      }
    },
    fullScreenElem: function () {
      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement
    },
    resize: function () {
      const main = this.$refs.main
      const res = this.$refs.res
      if (main) {
        let HEADERSIZE = 0
        let RES = 1024 / 768
        let EXT_HEIGHT = window.innerHeight
        const EXT_WIDTH = window.parent.innerWidth
        const fullScreenElem = this.fullScreenElem()
        if (fullScreenElem) {
          this.fullscreenMode = true
        } else {
          this.fullscreenMode = false
        }
        if (this.inIframe() && !fullScreenElem) {
          HEADERSIZE = 128
          RES = 0.7
          EXT_HEIGHT = window.parent.innerHeight
        }
        if (fullScreenElem) {
          RES = 0.75
        }
        this.rotate = false
        if (EXT_HEIGHT > 1024 && EXT_WIDTH > 700 && EXT_WIDTH < 1024) {
          // this.rotate = true
        }
        if (main) {
          const vw = window.parent.innerWidth * RES
          const vh = Math.max(530, EXT_HEIGHT - HEADERSIZE)
          main.style.height = Math.min(vw, vh) + 'px'
        }
        if (res) {
          res.style.height = (window.parent.innerHeight - HEADERSIZE) + 'px'
        }
      }
      if (this.inIframe()) {
        parent.postMessage('resize')
      }
      // const scale = Math.min(1.0, Math.max(0.5, document.body.clientWidth / 1540))
      // this.$refs.challenge.style.transform = 'scale(' + scale.toFixed(2) + ')'
      // this.$refs.tablet.style.transform = 'scale(' + scale.toFixed(2) + ')'
      // this.$refs.tutorial.$el.style.transform = 'scale(' + scale.toFixed(2) + ')'
      this.$forceUpdate()
    },
    inIframe: function () {
      const fullScreen = this.fullScreenElem()
      try {
        const differentWindow = (window.self !== window.top)
        return differentWindow && !fullScreen
      } catch (e) {
        return !fullScreen
      }
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.version{
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 2px 8px;
  font-size: 14px;
  color: #666;
}
.tablet-icon{
  transform: rotate(-90deg);
}
.fullscreen{
  position: absolute;
  right: 20px;
  bottom: 18px;
  padding: 0;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content:center;
  align-items: center;
  z-index: 1;
  img{
    display: inline-block;
    width: 26px;
    height: 26px;
    opacity: 0.8;
    &:hover{
      width: 28px;
      height: 28px;
      opacity: 1;
    }
  }
}
</style>
